import {ValueType} from '@/api/meta/filters';
import {ApiSortOrder, ApiSortsDerived} from '@/api/meta/odata';
import {getPicklists} from '@/api/module/picklist';
import Picklist, {ApiPicklist, ApiPicklistState, ApiPicklistType, PicklistFilters} from '@/model/Picklist';
import {createVersionedStorage} from './types';
import {fulltextToDisplay, toDisplay} from '@/util/store';

export const picklistStateFilterData = {
  [ApiPicklistState.Active]: {
    text: 'in Bearbeitung',
    color: 'primary-lighten-1',
    icon: 'lock',
  },
  [ApiPicklistState.Todo]: {
    text: 'offen',
    color: 'primary',
    icon: undefined,
  },
  [ApiPicklistState.Parked]: {
    text: 'geparkt',
    color: 'orange-accent-4',
    icon: 'pause-circle',
  },
  [ApiPicklistState.Done]: {
    text: 'erledigt',
    color: 'success',
    icon: 'check-circle',
  },
} as const;

export const picklistTypeFilterData = {
  [ApiPicklistType.Internal]: {
    text: 'interner Auftrag',
  },
  [ApiPicklistType.Order]: {
    text: 'Auftrag',
  },
  [ApiPicklistType.Tour]: {
    text: 'Tour',
  },
  [ApiPicklistType.Incoming]: {
    text: 'eingehend',
  },
  [ApiPicklistType.Inventory]: {
    text: 'Inventur',
  },
  [ApiPicklistType.Suggestion]: {
    text: 'Bestellvorschlag',
  },
  [ApiPicklistType.Correction]: {
    text: 'Bestandskorrektur',
  },
  [ApiPicklistType.Umbuchung]: {
    text: 'Lager zu Lager Buchung',
  },
} as const;

// const filterNames: Record<keyof PicklistFilters, string | null> = {
//   'Art$In': null,
//   'Status$In': null,
//   'Fulltext$Fulltext': 'Suche',
//   'Kmsdatum$From': 'Datum von',
//   'Kmsdatum$To': 'Datum bis',
//   'Kmsbediener': 'Bediener',
// };

const usePicklistsStore = createVersionedStorage<
  PicklistFilters, ApiSortsDerived<ApiPicklist>, Picklist[]
>('picklists', {
  fetchFn: getPicklists,
  defaultData: [],
  defaultFilters: {
    Status$In: [ApiPicklistState.Todo, ApiPicklistState.Parked],
    Fulltext$Fulltext: {
      words: [], fields: [
        {
          path: ['Tour', 'Tournr'],
          valueType: ValueType.Naked,
        },
        {
          path: ['Picklistnr'],
          valueType: ValueType.Naked,
        },
        {
          path: ['Tour', 'KfzKennzeichen'],
          valueType: ValueType.StringContains,
        },
        {
          path: ['Auftraege', 'Belegnr'],
          valueType: ValueType.Naked,
        },
        {
          path: ['InterneAuftraege', 'Belegnr'],
          valueType: ValueType.Naked,
        },
        {
          path: ['Auftraege', 'Name'],
          valueType: ValueType.StringContains,
        },
        {
          path: ['Kmsbediener'],
          valueType: ValueType.StringContains,
        },
      ],
    },
  },
  defaultSorts: [['Kmsdatum', ApiSortOrder.Asc], ['Kmsprioritaet', ApiSortOrder.Desc]],
  alwaysSorted: [['Kmsprioritaet', ApiSortOrder.Desc]],
  defaultLimit: 50,
  formatter: {
    Art$In(value) {
      if (value) {
        return value.map((val, indx) => ({
          text: picklistTypeFilterData[val].text,
          keypath: [indx.toString()],
        }));
      }
      return undefined;
    },
    Status$In(value) {
      if (value) {
        return value.map((val, indx) => ({
          ...picklistStateFilterData[val],
          keypath: [indx.toString()],
        }));
      }
      return undefined;
    },
    Fulltext$Fulltext: fulltextToDisplay,
    Kmsdatum$From: toDisplay('Datum von'),
    Kmsdatum$To: toDisplay('Datum bis'),
    Kmsbediener: toDisplay('Bediener'),
  },
  // convertFilterToDisplayFn: createConvertFiltersToDisplayFn(
  //     createGetRowFn({
  //       getLabel: ({actualKeys}) => filterNames[actualKeys[0] as keyof PicklistFilters],
  //       getValue: ({actualKeys, value}) => {
  //         switch (actualKeys[0] as keyof PicklistFilters) {
  //           case 'Status$In':
  //             return picklistStateFilterData[value as ApiPicklistState].text;
  //           case 'Art$In':
  //             return picklistTypeFilterData[value as ApiPicklistType].text;
  //         }
  //       },
  //       getColor: ({actualKeys, value}) => {
  //         if (actualKeys[0] === 'Status$In') return picklistStateFilterData[value as ApiPicklistState].color;

  //         return undefined;
  //       },
  //       getIcon: ({actualKeys, value}) => {
  //         if (actualKeys[0] === 'Status$In') return picklistStateFilterData[value as ApiPicklistState].icon;

  //         return undefined;
  //       },
  //     }),
  // ),
});

export default usePicklistsStore;
